import { StateProvider } from '@bryntum/grid';
import { firstValueFrom } from 'rxjs';
import { BryntumGridStateService } from './bryntum-grid-state.service';

export class BryntumGridStateProvider {
    private saving = false;
    private pendingData: any = null;
    private stateProvider = StateProvider.instance;

    constructor(
        private bryntumGridStateService: BryntumGridStateService,
        private componentTypeId: number,
        private stateId: string
    ) { }

    async init() {
        try {
            // 1. load existing state
            const data: any = await firstValueFrom(
                this.bryntumGridStateService.loadGridState(this.componentTypeId)
            );
            if (data) {
                const state = {
                    columns: JSON.parse(data.Columns),
                    rowHeight: JSON.parse(data.RowHeight),
                    scroll: JSON.parse(data.Scroll),
                    selectedRecords: JSON.parse(data.SelectedRecords),
                    store: JSON.parse(data.Store),
                    style: JSON.parse(data.Style),
                    subGrids: JSON.parse(data.SubGrids),
                };

              if (state.columns !== null) {
                this.stateProvider.clear();

                // ← add this delay
                await new Promise(resolve => setTimeout(resolve, 500));

                this.stateProvider.setValue(this.stateId, state);
              }
            }

            // 2. listen for future saves
            this.stateProvider.on('save', this.onSave, this);
        }
        catch (err) {
            console.error('Error initializing grid state provider', err);
        }
    }


    private onSave() {
        this.pendingData = this.stateProvider.data;
        if (!this.saving) {
            this.persist().catch(e => console.warn('Save failed', e));
        }
    }

    private async persist() {
        this.saving = true;
        try {
            while (this.pendingData) {
                const bucket = this.pendingData;
                this.pendingData = null;
                await firstValueFrom(
                    this.bryntumGridStateService.saveGridState(
                        this.componentTypeId,
                        bucket[this.stateId]
                    )
                );
            }
        } finally {
            this.saving = false;
        }
    }

    // call this in your component's ngOnDestroy()
    destroy() {
        this.stateProvider.un('save', this.onSave, this);
    }
}
